export default __webpack_public_path__ + "static/media/Signup_3.8e477744.png";